import { api } from "@/lib/api";

function parseFilename(contentDisposition, fallback = "download") {
  if (!contentDisposition) return fallback;
  const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch?.[1]) return decodeURIComponent(utfMatch[1]);
  const simpleMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  return simpleMatch?.[1] || fallback;
}

export async function createProtectedObjectUrl(path) {
  const { data } = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(data);
}

export async function downloadProtectedFile(path, fallbackFilename = "download") {
  const response = await api.get(path, { responseType: "blob" });
  const filename = parseFilename(response.headers?.["content-disposition"], fallbackFilename);
  const blobUrl = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}
